import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import getTypeIcon from '../../assets/typeIcons';
let ArrayItemNode = class ArrayItemNode extends Vue {
  constructor() {
    super(...arguments);
    this.expanded = false;
  }
  get renderType() {
    var _schema$fields, _schema$enum;
    const {
      schema
    } = this;
    if (schema.type === 'object' && (_schema$fields = schema.fields) !== null && _schema$fields !== void 0 && _schema$fields.length) {
      return 'object';
    }
    if (schema.type === 'array') {
      var _schema$items, _schema$items2;
      if (((_schema$items = schema.items) === null || _schema$items === void 0 ? void 0 : _schema$items.type) === 'object' && (_schema$items2 = schema.items) !== null && _schema$items2 !== void 0 && (_schema$items2 = _schema$items2.fields) !== null && _schema$items2 !== void 0 && _schema$items2.length) {
        return 'array';
      }
      return 'simpleArray';
    }
    if ((_schema$enum = schema.enum) !== null && _schema$enum !== void 0 && _schema$enum.length) {
      return 'enum';
    }
    return 'simple';
  }
  get expandable() {
    return ['object', 'array'].includes(this.schema.type || '');
  }
  toggleExpand() {
    this.expanded = !this.expanded;
  }
  renderExpand() {
    const h = this.$createElement;
    return this.expandable ? h("i", {
      "class": ['ucd-dataTreeNode-expand', `fa fa-${this.expanded ? 'caret-down' : 'caret-right'}`],
      "attrs": {
        "aria-hidden": "true"
      }
    }) : h("div", {
      "class": "ucd-dataTreeNode-expand"
    });
  }
  renderChildrens() {
    var _fields;
    const h = this.$createElement;
    const {
      schema,
      renderType
    } = this;
    let fields = null;
    if (this.renderType === 'array') {
      fields = schema.items.fields;
    }
    if (this.renderType === 'object') {
      fields = schema.fields;
    }
    if (this.renderType === 'enum') {
      fields = schema.enum.map(el => {
        const type = typeof el.value;
        const renderQuote = type === 'string' ? '"' : '';
        const id = `${el.label || el.value}(${renderQuote}${el.value}${renderQuote})`;
        return {
          id,
          type,
          required: true
        };
      });
    }
    const isArray = schema.type === 'array';
    const isSimpleArray = renderType === 'simpleArray';
    const isEnum = this.renderType === 'enum';
    let openTag = null;
    let closeTag = null;
    if (isArray) {
      var _schema$items3;
      openTag = h("div", {
        "class": "ucd-array-items-prefix"
      }, [`Array [${isSimpleArray ? '' : '{'}`, " "]);
      closeTag = [h("div", {
        "class": "ucd-array-items-prefix"
      }, [`${isSimpleArray ? '' : '}'}]`])];
      if (isSimpleArray) closeTag.unshift(h("div", {
        "class": "ucd-array-items-tag"
      }, [((_schema$items3 = schema.items) === null || _schema$items3 === void 0 ? void 0 : _schema$items3.type) || 'any']));
    } else if (isEnum) {
      openTag = h("div", {
        "class": "ucd-array-items-prefix"
      }, ['Enum [', " "]);
      closeTag = h("div", {
        "class": "ucd-array-items-prefix"
      }, [" ", ']', " "]);
    }
    return h("div", {
      "class": 'ucd-array-items-tree'
    }, [h("div", {
      "class": "ucd-array-items-indent"
    }), h("div", [openTag, (_fields = fields) === null || _fields === void 0 ? void 0 : _fields.map((item, index) => this.$createElement('ArrayItemNode', {
      props: {
        schema: item,
        depth: this.depth + 1
      },
      key: index
    })), closeTag])]);
  }
  render() {
    const h = arguments[0];
    const {
      schema
    } = this;
    const img = h("img", {
      "class": "ucd-dataTreeNode-icon",
      "attrs": {
        "src": getTypeIcon(schema.type)
      }
    });
    let node = !this.showChildrenOnly && h("div", _mergeJSXProps([{
      "class": 'ucd-array-items-node',
      "attrs": {
        "expandable": this.expandable
      }
    }, {
      "on": this.expandable ? {
        click: this.toggleExpand
      } : {}
    }]), [this.renderExpand(), img, h("div", [schema.id, " ", schema.title ? `(${schema.title})` : '']), schema.type === 'array' && h("span", {
      "class": "ucd-array-items-tag"
    }, ["\u6570\u7EC4"]), schema.type === 'object' && h("span", {
      "class": "ucd-array-items-tag"
    }, ["\u5BF9\u8C61"]), schema.isPrimaryKey && h("a-tooltip", {
      "attrs": {
        "title": `${schema.id}为实体主键`
      }
    }, [h("a-icon", {
      "class": 'ucd-array-items-key',
      "attrs": {
        "type": 'key'
      }
    })])]);
    if (node) {
      node = this.renderType === 'simple' ? node : h("a-tooltip", {
        "attrs": {
          "title": `展开查看${this.renderType === 'array' ? '数组类型' : '对象类型'}`
        }
      }, [node]);
    }
    return h("div", {
      "class": this.depth === 0 ? 'ucd-array-items-tree-root' : ''
    }, [node, (this.expanded || this.showChildrenOnly) && this.renderChildrens()]);
  }
};
__decorate([Prop()], ArrayItemNode.prototype, "schema", void 0);
__decorate([Prop({
  default: false
})], ArrayItemNode.prototype, "showChildrenOnly", void 0);
__decorate([Prop({
  default: 0
})], ArrayItemNode.prototype, "depth", void 0);
ArrayItemNode = __decorate([Component({
  name: 'ArrayItemNode'
})], ArrayItemNode);
export { ArrayItemNode };
//# sourceMappingURL=ArrayItemsTree.js.map
